var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.adItem && _vm.adItem.content)?_c('div',{staticClass:"text-center",staticStyle:{"background":"#E6E6E6"}},[_c('video',{staticClass:"ad-design",attrs:{"src":_vm.adItem.content,"loop":"","autoplay":"","controls":"","muted":""},domProps:{"muted":true}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }